import Cart from "../components/Cart/Cart";

const Carts = (props) => {
  return (
    <Cart
      id={props.id}
      loading={props.isLoading}
      isLoading={props.setIsLoading}
      hideCart={props.hideCart}
    />
  );
};

export default Carts;
